module.exports = __webpack_public_path__ + "img/noresult.a10ef449.svg";